// removed by extract-text-webpack-plugin
module.exports = {"section":"src-components----email-module---section---34Ppm","form":"src-components----email-module---form---3aHRd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/email.module.css
// module id = 62
// module chunks = 35783957827783 96961042003272 262518743708968